/*
  CardsByBeard — bestellimieten in de winkel.

  De limieten staan in het winkel-metaveld cardsbybeard.limieten (beheerd in de CardsByBeard-app) en komen
  via layout/theme.liquid binnen als window.cbLimiet = { limieten, ingelogd, login, gekocht }.

  Dit script houdt klanten tegen vóór het afrekenen:
  - op de productpagina: uitleg onder de koopknop en een maximum op het aantal;
  - in de winkelwagen: te hoge aantallen worden teruggezet, met een melding.
  Wie hier omheen werkt, wordt achteraf gepakt door de app (elke bestelling wordt nagekeken).
  De rekenregels zijn dezelfde als in de app (app/lib/limieten.ts).
*/
(function () {
  'use strict';

  var cfg = window.cbLimiet;
  if (!cfg || !cfg.limieten) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function limiet(productId) {
    var l = cfg.limieten[String(productId)];
    return l && l.aan !== false ? l : null;
  }

  function periodeTekst(uren) {
    if (uren % 24 === 0) return uren === 24 ? '24 uur' : uren / 24 + ' dagen';
    return uren + ' uur';
  }

  // Al gekocht binnen de periode (alleen bekend voor ingelogde klanten)
  function gekocht(productId, l) {
    if (!l.perPeriode || !l.periodeUren) return 0;
    var vanaf = Date.now() / 1000 - l.periodeUren * 3600;
    return (cfg.gekocht || []).reduce(function (som, a) {
      return String(a.p) === String(productId) && a.t >= vanaf ? som + a.q : som;
    }, 0);
  }

  // Hoeveel er nu nog in de winkelwagen mag; Infinity = geen grens
  function ruimte(productId) {
    var l = limiet(productId);
    if (!l) return Infinity;
    if (l.inloggen && !cfg.ingelogd) return 0;
    var max = l.perBestelling || Infinity;
    if (l.perPeriode) max = Math.min(max, l.perPeriode - gekocht(productId, l));
    return Math.max(0, max);
  }

  function esc(tekst) {
    return String(tekst == null ? '' : tekst).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Uitleg voor de klant, als HTML
  function uitleg(productId) {
    var l = limiet(productId);
    if (!l) return '';
    if (l.inloggen && !cfg.ingelogd) {
      return 'Dit product is alleen te bestellen met een account. <a href="' + esc(cfg.login) + '">Log in</a> om te bestellen.';
    }
    var regels = [];
    if (l.perBestelling) regels.push('maximaal ' + l.perBestelling + ' per bestelling');
    if (l.perPeriode && l.periodeUren) regels.push('maximaal ' + l.perPeriode + ' per klant per ' + periodeTekst(l.periodeUren));
    var tekst = regels.join(' en ');
    tekst = tekst.charAt(0).toUpperCase() + tekst.slice(1) + '.';
    if (ruimte(productId) === 0) tekst += ' Je hebt dit maximum bereikt.';
    return tekst;
  }

  // ── Productpagina ──
  function productpagina() {
    document.querySelectorAll('[data-cb-limiet]').forEach(function (el) {
      var id = el.getAttribute('data-cb-limiet');
      var html = uitleg(id);
      if (!html) return;
      if (el.innerHTML !== html) el.innerHTML = html;
      if (el.hidden) el.hidden = false;

      var r = ruimte(id);
      var sectie = el.closest('.shopify-section') || document;
      var aantal = sectie.querySelector('.quantity__input');
      if (aantal && r !== Infinity && r > 0) {
        if (aantal.getAttribute('max') !== String(r)) aantal.setAttribute('max', r);
        if (aantal.getAttribute('data-max') !== String(r)) aantal.setAttribute('data-max', r);
        if (Number(aantal.value) > r) aantal.value = r;
      }
      if (r === 0) {
        var knop = el.closest('form') && el.closest('form').querySelector('[name="add"]');
        if (knop && !knop.disabled) knop.disabled = true;
      }
    });
  }

  // ── Winkelwagen: te hoge aantallen terugzetten ──
  var MELDING = 'cb-limiet-melding';

  function toonMelding(html) {
    var oud = document.getElementById(MELDING);
    if (oud) oud.remove();
    if (!html) return;
    var plek = document.querySelector('cart-drawer .drawer__header') || document.querySelector('cart-items, .cart-items, main');
    if (!plek) return;
    var el = document.createElement('p');
    el.id = MELDING;
    el.className = 'cb-limiet-melding';
    el.setAttribute('role', 'alert');
    el.innerHTML = html;
    plek.insertAdjacentElement(plek.matches('.drawer__header') ? 'afterend' : 'afterbegin', el);
  }

  var bezig = false;

  function bewaak() {
    if (bezig) return;
    bezig = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var perProduct = {};
        (cart.items || []).forEach(function (item) {
          (perProduct[item.product_id] = perProduct[item.product_id] || []).push(item);
        });

        var updates = {};
        var meldingen = [];
        Object.keys(perProduct).forEach(function (id) {
          var r = ruimte(id);
          if (r === Infinity) return;
          var regels = perProduct[id];
          var totaal = regels.reduce(function (som, item) {
            return som + item.quantity;
          }, 0);
          if (totaal <= r) return;

          // Van achteren af verminderen tot het past
          var over = totaal - r;
          regels
            .slice()
            .reverse()
            .forEach(function (item) {
              if (over <= 0) return;
              var eraf = Math.min(item.quantity, over);
              updates[item.key] = item.quantity - eraf;
              over -= eraf;
            });
          var titel = '<strong>' + esc(regels[0].product_title) + '</strong>';
          meldingen.push(r === 0 ? titel + ' is uit je winkelwagen gehaald. ' + uitleg(id) : 'Aantal van ' + titel + ' aangepast naar ' + r + '. ' + uitleg(id));
        });

        if (!Object.keys(updates).length) {
          bezig = false;
          return;
        }

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (state) {
            var html = meldingen.join('<br>');
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function' && state.sections && !/\/cart\/?$/.test(window.location.pathname)) {
              drawer.classList.toggle('is-empty', state.item_count === 0);
              drawer.renderContents(state);
              setTimeout(function () {
                toonMelding(html);
                bezig = false;
              }, 60);
            } else {
              // Winkelwagenpagina: opnieuw laden en de melding daarna tonen
              try {
                sessionStorage.setItem(MELDING, html);
              } catch (e) {}
              window.location.reload();
            }
          });
      })
      .catch(function () {
        bezig = false;
      });
  }

  var timer = null;
  function plan() {
    clearTimeout(timer);
    timer = setTimeout(bewaak, 200);
  }

  function start() {
    productpagina();
    try {
      var bewaard = sessionStorage.getItem(MELDING);
      if (bewaard) {
        sessionStorage.removeItem(MELDING);
        toonMelding(bewaard);
      }
    } catch (e) {}
    bewaak();

    // Dawn meldt elke wijziging van de winkelwagen (toevoegen, aantal, verwijderen)
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, plan);
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(productpagina, 50);
        });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
